import { useState } from "react";
import ItemMenu from "../ItemMenu/item-menu";
import "./Menu.css";
import Logo from "../../assets/Logo/Logo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowClose } from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation } from "react-router-dom";
import user from "../../assets/user-d.png";
import { DialogCloseSession } from "../DialogCloseSession/DialogCloseSesion";
import LogoAccion from "../../assets/Logo/logoaccion.png";

export const Menu = (props) => {
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");

  const [open, setOpen] = useState(false);
  const [activePath, setActivePath] = useState("");

  const setActive = (path) => setActivePath(path);


  const logoutOption = () => setOpen(true);

  return (
    <div className="menu">
      <DialogCloseSession open={open} setOpen={setOpen} />
      <div className="menu-header">
        <div className="btn-float">
          {props.actions.windowsMinimize && (
            <FontAwesomeIcon
              style={{
                width: "25px",
                height: "25px",
                color: "#1c4fc1",
                cursor: "pointer",
              }}
              onClick={props.actions.hideFloatMenu}
              icon={faWindowClose}
            />
          )}
        </div>
        {/* TODO Logo de devise o accion */}
        <div className="menu-text">
          {/* <Logo width="80%" height="80%" /> */}
          <img src={LogoAccion} alt="Logo Acción" style={{ width: '60%'}} />
        </div>
      </div>
      <div className="content-items">
        <div className="_card-user">
          <div className="user-image">
            <div className="user-image-box">
              <img
                src=""
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // looping
                  currentTarget.src = user;
                }}
              />
            </div>
          </div>
          <div className="_card-column">
            <div title="Pablo Doe" className="_card-header">
              Pablo Doe
            </div>
            <div className="_card-body">Eres Inversionista</div>
          </div>
        </div>
        <div className="items-group">
          <div className="items-group-title">General</div>
          <div className="item-container">
            {/* <div className="item-box drop-down"> */}
            <div className="item-box" onClick={() => setActive("dashboard")}>
              <Link to="/dashboard">
                <ItemMenu
                  text="Mi Tablero"
                  icon="IconDashboard"
                  active={
                    splitLocation.length > 1 && splitLocation[1] == "dashboard"
                  }
                />
              </Link>
            </div>
            <div className="item-childs none"></div>
          </div>
          <div className="item-container">
            <div className="item-box" onClick={() => setActive("invertir")}>
              <Link to="/invertir">
                <ItemMenu
                  text="Quiero invertir"
                  icon="IconInvest"
                  active={
                    splitLocation.length > 1 && splitLocation[1] == "invertir"
                  }
                />
              </Link>
            </div>
            <div className="item-childs none"></div>
          </div>
          <div className="item-container">
            <div
              className="item-box"
              onClick={() => setActive("mi-portafolio")}
            >
              <Link to="/mi-portafolio">
                <ItemMenu
                  text="Mi Portafolio"
                  icon="IconInvestments"
                  active={
                    splitLocation.length > 1 &&
                    splitLocation[1] == "mi-portafolio"
                  }
                />
              </Link>
            </div>
            <div className="item-childs none"></div>
          </div>
          <div className="item-container">
            <div
              className="item-box"
              onClick={() => setActive("mis-movimientos")}
            >
              <Link to="/mis-movimientos">
                <ItemMenu
                  text="Mis Movimientos"
                  icon="IconMovements"
                  active={
                    splitLocation.length > 1 &&
                    splitLocation[1] == "mis-movimientos"
                  }
                />
              </Link>
            </div>
            <div className="item-childs none"></div>
          </div>
          {/* <label id="admin-activos" className="item-container">
            <div className="item-box" onClick={() => setActive("mis-activos")}>
              <Link to="/mis-activos">
                <ItemMenu
                  text="Mis Activos"
                  icon="IconInvest"
                  activePath={activePath}
                  active={
                    splitLocation.length > 1 &&
                    splitLocation[1] === "mis-activos"
                  }
                />
              </Link>
            </div>
            <div className="item-childs none"></div>
          </label>
          <label id="admin-activos" className="item-container">
            <div
              className="item-box"
              onClick={() => setActive("admin-activos")}
            >
              <ItemMenu
                text="Admin Activos"
                icon="IconInvest"
                parentMenu={true}
                activePath={activePath}
                splitLocation={"admin-activos"}
                active={
                  splitLocation.length > 1 &&
                  splitLocation[1] === "admin-activos"
                }
              />
              <i className="arrow right"></i>
              <input
                type="checkbox"
                onChange={(e) => setActiveMenu(e, "admin-activos")}
                hidden={true}
                checked={subMenuH.item === "admin-activos" && subMenuH.chck}
              />
            </div>
            <AnimateHeight
              duration={300}
              height={
                subMenuH.item &&
                subMenuH.item === "admin-activos" &&
                subMenuH.chck
                  ? subMenuH.height
                  : 0
              }
            >
              <div
                id="list-admin-activos"
                className={
                  splitLocation.length > 1 &&
                  splitLocation[1] === "admin-activos"
                    ? "item-childs list"
                    : "item-childs none"
                }
              >
                <Link to="/admin-activos">
                  <ItemMenu
                    text="Pendientes aprobación Sponsor"
                    icon="IconInvest"
                    subMenu={true}
                    splitLocation={"admin-activos"}
                    active={
                      splitLocation.length > 1 &&
                      splitLocation[1] === "admin-activos" &&
                      (splitLocation[2] !== "admin" ||
                        (splitLocation[2] && /^[0-9]+$/.test(splitLocation[2])))
                    }
                  />
                </Link>
                <Link to="/admin-activos/admin">
                  <ItemMenu
                    text="Pendientes Aprobación Devise"
                    icon="IconInvest"
                    splitLocation={"admin-activos"}
                    subMenu={true}
                    active={
                      splitLocation.length > 1 &&
                      splitLocation[1] === "admin-activos" &&
                      splitLocation[2] === "admin"
                    }
                  />
                </Link>
              </div>
            </AnimateHeight>

            <input
                  type="checkbox"
                  onChange={(e) => setActiveMenu(e, "admin-activos")}
                  hidden={true}
                  id="chck-admin-activos"
                />
          </label> */}
        </div>

        <div className="items-group">
          <div className="items-group-title">Tu cuenta</div>
          <div className="item-container">
            <div className="item-box" onClick={() => setActive("cuenta")}>
              <Link to="/cuenta">
                <ItemMenu
                  text="Cuenta"
                  icon="IconAccount"
                  active={
                    splitLocation.length > 1 && splitLocation[1] == "cuenta"
                  }
                />
              </Link>
            </div>
            <div className="item-childs none"></div>
          </div>
          {/* <div className="item-container">
            <div className="item-box" onClick={() => setActive("mi-empresa")}>
              <Link to="/mi-empresa">
                <ItemMenu
                  text="Mi Empresa"
                  icon="IconInvest"
                  active={
                    splitLocation.length > 1 && splitLocation[1] == "mi-empresa"
                  }
                />
              </Link>
            </div>
            <div className="item-childs none"></div>
          </div> */}
          <div className="item-container">
            <div className="item-box" onClick={() => setActive("referidos")}>
              <Link to="/referidos">
                <ItemMenu
                  text="Referidos"
                  icon="IconReferals"
                  active={
                    splitLocation.length > 1 && splitLocation[1] == "referidos"
                  }
                />
              </Link>
            </div>
            <div className="item-childs none"></div>
          </div>
          <div className="item-container">
            <div className="item-box" onClick={() => setActive("seguridad")}>
              <Link to="/seguridad">
                <ItemMenu
                  text="Seguridad"
                  icon="IconSecurity"
                  active={
                    splitLocation.length > 1 && splitLocation[1] == "seguridad"
                  }
                />
              </Link>
            </div>
            <div className="item-childs none"></div>
          </div>
          <div className="item-container">
            <div className="item-box" onClick={() => setActive("academia")}>
              <Link to="/academia">
                <ItemMenu
                  text="Academia"
                  icon="IconAcademy"
                  active={
                    splitLocation.length > 1 && splitLocation[1] == "academia"
                  }
                />
              </Link>
            </div>
            <div className="item-childs none"></div>
          </div>
          <div className="item-container">
            <div
              className="item-box"
              onClick={() => setActive("ayuda-y-soporte")}
            >
              <Link to="/ayuda-y-soporte">
                <ItemMenu
                  text="Ayuda y soporte"
                  icon="IconHelpSupport"
                  active={
                    splitLocation.length > 1 &&
                    splitLocation[1] == "ayuda-y-soporte"
                  }
                />
              </Link>
            </div>
            <div className="item-childs none"></div>
          </div>
          <div className="item-container">
            <div className="item-box" onClick={logoutOption}>
              <ItemMenu text="Cerrar Sesión" icon="IconLogOut" active={false} />
            </div>
            <div className="item-childs none"></div>
          </div>
        </div>
      </div>
      {/* <div className="incomplete-profile">
        <div className="items-group">
          <div className="item-container">
            <div className="items-group-title">Tu cuenta</div>
            <div className="item-box">
              <Link to="/completar-perfil">
                <ItemMenu text="Cuenta" icon="IconAccount" active={true} />
              </Link>
            </div>
            <div className="item-childs none"></div>
          </div>
          <div className="item-container">
            <div className="item-box" onClick={logoutOption}>
              <ItemMenu text="Cerrar Sesión" icon="IconLogOut" active={false} />
            </div>
            <div className="item-childs none"></div>
          </div>
        </div>
      </div> */}
    </div>
  );
};
